import React from "react";
import "./App.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Layout from "./components/layout";
import Loader from "./components/loader";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Loader />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
